module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/temperature-full-f4d5f210cfe226882eb56c87a2ae12ce.svg";